import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

// Phase F: Map of backend notification types to display labels
// TODO for backend: emit partial_progress, partial_decision, partial_quote_sent events
// Currently derived client-side from dashboard KPI fetch as a stopgap.
const NOTIF_TYPE_LABELS = {
  partial_progress: (item) => item.message || `RFQ ${item.rfqId || ''} has partial lines quoted`,
  partial_decision: (item) => item.message || `RFQ ${item.rfqId || ''} has lines undecided`,
  partial_quote_sent: (item) => item.message || `Customer quote issued for subset of lines on RFQ ${item.rfqId || ''}`,
};

export default function NotificationBell() {
  const [data, setData] = useState({ total: 0, items: [] });
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const intRef = useRef(null);

  async function poll() {
    try {
      const r = await api.notifications();
      // Normalize items: apply label functions for known notification types
      const items = (r.items || []).map((it) => {
        const labelFn = NOTIF_TYPE_LABELS[it.type];
        return labelFn ? { ...it, message: labelFn(it) } : it;
      });
      setData({ ...r, items });
    } catch (_) { /* silent on failure */ }
  }

  useEffect(() => {
    poll();
    function onFocusChange() {
      if (document.hidden) {
        clearInterval(intRef.current);
      } else {
        poll();
        intRef.current = setInterval(poll, 30000);
      }
    }
    intRef.current = setInterval(poll, 30000);
    document.addEventListener('visibilitychange', onFocusChange);
    return () => {
      clearInterval(intRef.current);
      document.removeEventListener('visibilitychange', onFocusChange);
    };
  }, []);

  function click(item) {
    setOpen(false);
    if (item.link) nav(item.link);
  }

  return (
    <div className="notif-wrap">
      <button className="btn btn-ghost notif-btn" aria-label={`${data.total} notifications`} onClick={() => setOpen((o) => !o)}>
        🔔
        {data.total > 0 && <span className="notif-dot">{data.total > 99 ? '99+' : data.total}</span>}
      </button>
      {open && (
        <div className="notif-panel" role="menu">
          <div className="notif-head">Notifications</div>
          {data.items.length === 0 ? (
            <div className="notif-empty">You're all caught up ✓</div>
          ) : data.items.map((it, i) => (
            <button key={i} className={'notif-item ' + (it.severity || 'info')} onClick={() => click(it)}>
              <div>{it.message}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
